// jwt.interceptor.ts
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Observable, EMPTY, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Token} from '../models/token';
import {StoragePortalService} from '../services/storage-portal.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private token: Token | null = null;

  constructor(
    private storage: StoragePortalService,
    private router: Router
  ) {
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // 1) Detectar si es flujo de auth
    const url = request.url;
    const isAuthFlow =
      url.endsWith('/token') ||
      url.endsWith('/status') ||
      url.endsWith('/user-info-recover');

    // 2) Leer token y clonar
    this.token = this.storage.token;
    let cloneReq = request;
    if (this.token && !url.endsWith('/token')) {
      cloneReq = request.clone({
        setHeaders: {
          Authorization: `${this.token.token_type} ${this.token.access_token}`
        }
      });
    }


    return next.handle(cloneReq).pipe(
      catchError(err => {
        // → Y aquí: si 401, vemos qué URL estaba fallando
        if (err.status === 401) {
          if (!isAuthFlow) {
            this.storage.clearToken();
            this.router.navigate(['/login']);
          }
          return EMPTY;
        }
        return throwError(() => err);
      })
    );
  }
}
